module.exports = __webpack_public_path__ + "static/header-img-ac3a5634f198a446d283bdb8d66b765f.jpg";